module.exports = __webpack_public_path__ + "static/1-378924bd81dbffa0164621171a5fb096.jpg";